module.exports = __webpack_public_path__ + "img/ListReturnIcon.210f57c3.svg";